import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=4b14af88&scoped=true"
import script from "./how-it-works.vue?vue&type=script&lang=js"
export * from "./how-it-works.vue?vue&type=script&lang=js"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=4b14af88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14af88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,ContactUsCard: require('/var/www/tubber-new/components/global/ContactUsCard.vue').default})
